<template>
  <div class="modal fade" id="modalDisapproved" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <div class="modal-body">
          <div class="modal-custom">
            <!-- Loading -->
            <div v-if="loadingModal" class="loading center_vertical">
              <div class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </div>

            <div class="modal-table">
              <h5><span>Motivo da Recusa</span></h5>

              <p class="text-info">{{dataMotive}}</p>
            </div>
          </div>

          <button v-if="!loadingModal" v-on:click="closeModal()" class="default-btn-back" type="button">Fechar</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { MOTIVE_DISAPPROVED } from "../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../requestConfig";
  import { UTIL_SERVICE } from "../../../utils";

  export default {
    name: "modal-disapproved",
    props:['dataModal'],
    data(){
      return {
        failRequestModal: false,
        loadingModal: false,
        idReq: '',
        dataMotive: ''
      }
    },
    watch: {
      dataModal: function (val) {
        this.idReq = val;

        this.getMotive();
      },
    },
    methods: {
      getMotive() {
        this.loadingModal = true;
        this.failRequestModal = false;
        REQUEST_SERVICE.get(MOTIVE_DISAPPROVED + "?id=" + this.idReq).then((response) => {
          UTIL_SERVICE.console("RESULT MOTIVE_DISAPPROVED:", response.data);

          this.dataMotive = response.data;
          this.loadingModal = false;
        }).catch(reason => {
          this.loadingModal = false;
          this.failRequestModal = true;
        });
      },
      closeModal(){
        $('#modalDisapproved').modal('toggle');
      }
    }
  }
</script>

<style lang="scss">
  .text-info {
    padding: 0 30px;
    margin-top: 20px;
    font-size: 15px;
    letter-spacing: 1px;
    color: #565151;
  }

  .default-btn-back {
    border-radius: 4px !important;
    background-color: #AAB5BC;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFFFFF;
    border: none;
    display: block;
    margin: 0 0 0 auto;

    &:hover, &:active, &:focus {
      background-color: #7b7878;
      color: #FFFFFF;
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/components/modalDisapproved.vue